(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.policies-tab-button');
    const tabPanes = document.querySelectorAll('.policies-tab-pane');
    const navBar = document.querySelector('.policies-tabs-nav');

    // Handle anchor link clicks
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Update active button
          tabButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');

          // Smooth scroll to target
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Update active button on scroll using IntersectionObserver
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          tabButtons.forEach(btn => {
            btn.classList.remove('active');
            if (btn.getAttribute('href') === '#' + sectionId) {
              btn.classList.add('active');
            }
          });
        }
      });
    }, observerOptions);

    tabPanes.forEach(pane => observer.observe(pane));

    // Handle hash navigation on page load
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const button = document.querySelector(`a[href="#${targetId}"]`);
          if (button) {
            tabButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
          }
        }, 100);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.shipping-tab-button');
    const tabPanes = document.querySelectorAll('.shipping-tab-pane');

    // Handle anchor link clicks
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Update active button
          tabButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');

          // Smooth scroll to target
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Update active button on scroll using IntersectionObserver
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          tabButtons.forEach(btn => {
            btn.classList.remove('active');
            if (btn.getAttribute('href') === '#' + sectionId) {
              btn.classList.add('active');
            }
          });
        }
      });
    }, observerOptions);

    tabPanes.forEach(pane => observer.observe(pane));

    // Handle hash navigation on page load
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const button = document.querySelector(`a[href="#${targetId}"]`);
          if (button) {
            tabButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
          }
        }, 100);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
